export const httpConfig = {
  postApi: "/api/v1",
  url:
    process.env.GATSBY_MULE_ALT_API_URL ??
    "https://exp-web-api-prod-ehk9je.dcebqh.deu-c1.eu1.cloudhub.io",
  apiPrefix: "/api/",
  apiSuffix: {
    leads: "/leads",
    suppliers: "/suppliers/applications",
    support: "/support/requests",
    catalogs: ["/catalogs/", "/downloads"],
  },
  googleMapsApi: "https://www.google.com/maps/search/?api=1&query=",
};
